import { api1 } from "../utils/axiosInstance";

export const fetchContacts = async () => {
  try {
    const response = await api1.get(`/api/user`);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};

// Legacy chat APIs (for general chat functionality)
export const getChatMessages = async (userId) => {
  try {
    const response = await api1.get(`/api/chat/history/${userId}`, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching chat messages:", error);
    return null;
  }
};

export const saveChatMessage = async (userId, sender, message) => {
  try {
    const response = await api1.post(
      `/api/chat/save`,
      { userId, sender, message },
      {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving chat message:", error);
    return null;
  }
};

// Conversation APIs (1-1 mentor-mentee chats)
export const saveConversationMessage = async (senderId, receiverId, senderType, receiverType, message) => {
  try {
    const response = await api1.post(
      `/api/conversation/save-message`,
      { senderId, receiverId, senderType, receiverType, message },
      {
        meta: { showToast: false },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving conversation message:", error);
    return null;
  }
};

export const getConversationMessages = async (senderId, receiverId) => {
  try {
    const response = await api1.get(`/api/conversation/messages/${senderId}/${receiverId}`, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching conversation messages:", error);
    return null;
  }
};

export const getUserConversations = async (userId) => {
  try {
    const response = await api1.get(`/api/conversation/user/${userId}`, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user conversations:", error);
    return null;
  }
};

export const markConversationMessagesAsRead = async (senderId, receiverId) => {
  try {
    const response = await api1.put(`/api/conversation/mark-read/${senderId}/${receiverId}`, {}, {
      meta: { showToast: false },
    });
    return response.data;
  } catch (error) {
    console.error("Error marking conversation messages as read:", error);
    return null;
  }
};
